import {
  AvailibilityIcon,
  CalanderIcon,
  CompeteIcon,
  LocationIcon,
  PriceRangeIcon,
  TeamIcon,
} from "../../components/GlobalIcons";
import { HOMEIMAGES } from "../IMAGES";

export const countriesList = [
  { iso: "GBR", country_name: "United Kingdom" },
  { iso: "ESP", country_name: "Spain" },
  { iso: "FRA", country_name: "France" },
  { iso: "DEU", country_name: "Germany" },
  { iso: "ITA", country_name: "Italy" },
  { iso: "PRT", country_name: "Portugal" },
  { iso: "AUS", country_name: "Australia" },
  { iso: "BHR", country_name: "Bahrain" },
  { iso: "VNM", country_name: "Vietnam" },
  { iso: "CHN", country_name: "China" },
  { iso: "NLD", country_name: "Netherlands" },
  { iso: "MCO", country_name: "Monaco" },
  { iso: "AZE", country_name: "Azerbaijan" },
  { iso: "CAN", country_name: "Canada" },
  { iso: "AUT", country_name: "Austria" },
  { iso: "HUN", country_name: "Hungary" },
  { iso: "BEL", country_name: "Belgium" },
  { iso: "SGP", country_name: "Singapore" },
  { iso: "RUS", country_name: "Russia" },
  { iso: "CZE", country_name: "Czech Republic" },
  { iso: "ARE", country_name: "United Arab Emirates" },
  { iso: "JPN", country_name: "Japan" },
  { iso: "USA", country_name: "United States of America" },
  { iso: "MEX", country_name: "Mexico" },
  { iso: "BRA", country_name: "Brazil" },
  { iso: "THA", country_name: "Thailand" },
  { iso: "ARG", country_name: "Argentina" },
  { iso: "FIN", country_name: "Finland" },
  { iso: "MYS", country_name: "Malaysia" },
  { iso: "QAT", country_name: "Qatar" },
  { iso: "SWE", country_name: "Sweden" },
  { iso: "TUR", country_name: "Turkey" },
  { iso: "SAU", country_name: "Saudi Arabia" },
  { iso: "IDN", country_name: "Indonesia" },
  { iso: "NOR", country_name: "Norway" },
  { iso: "KAZ", country_name: "Kazakhstan" },
  { iso: "IND", country_name: "India" },
  { iso: "HRV", country_name: "Croatia" },
  { iso: "SRB", country_name: "Serbia" },
  { iso: "ROU", country_name: "Romania" },
  { iso: "AND", country_name: "Andorra" },
  { iso: "SVN", country_name: "Slovenia" },
  { iso: "POL", country_name: "Poland" },
];

export const SPORTSCONTENT = [
  {
    sport_type: "soccer",
    image: HOMEIMAGES.PORTALIMAGE,
    text: " Find the best official football tickets by choosing one of the most visited clubs below or choose the buttons below to see all available football matches",
  },
  {
    sport_type: "motorsport",
    image: HOMEIMAGES.MOTORSPORT,
    text: "Find the best official motorsport tickets by choosing one of the most popular events below or use the buttons below to explore all available motorsport races",
  },
  {
    sport_type: "rugby",
    image: HOMEIMAGES.RUGBY,
    text: "Discover the best official rugby tickets by selecting one of the most renowned teams below or use the buttons to explore all available rugby matches.",
  },
  {
    sport_type: "tennis",
    image: HOMEIMAGES.TENNIS,
    text: "Explore the finest official tennis tickets by selecting one of the top-ranked tournaments below or use the buttons to view all available tennis matches.",
  },
  {
    sport_type: "boxing",
    image: HOMEIMAGES.BOXING,
    text: "Find the best official boxing tickets by choosing one of the premier events below or use the buttons to explore all available boxing matches.",
  },
  {
    sport_type: "darts",
    image: HOMEIMAGES.DARTS,
    text: "Discover the excitement of darts by exploring the top tournaments and matches below, or use the options to find all upcoming darts events and tickets."
  },
  {
    sport_type: "horseracing",
    image: HOMEIMAGES.HORSERACING,
    text: "Experience the thrill of horse racing by exploring premier races and events below, or use the options to uncover all upcoming horse racing action and tickets."
  },
  {
    "sport_type": "motogp",
    "image": HOMEIMAGES.MOTOGP,
    "text": "Feel the adrenaline of MotoGP by exploring the top races and championships below, or use the options to find all upcoming MotoGP events and tickets."
  },
  {
    "sport_type": "cricket",
    "image": HOMEIMAGES.CRICKET,
    "text": "Immerse yourself in the excitement of cricket by exploring top matches and tournaments below, or use the options to find all upcoming cricket events and tickets."
  }

];

export const competitionData = [
  {
    id: 1,
    content:
      "The place to enjoy speed, excitement and to get your shot of adrenaline. Make your clients happy with the best tickets for the best price.",
    chipTtitle: "",
    official_name: "Formula 1",
    sportUrl: "motogp",
    class: "one",
  },
  {
    id: 2,
    content:
      "The place to enjoy speed, excitement and to get your shot of adrenaline. Make your clients happy with the best tickets for the best price.",
    chipTtitle: "",
    official_name: "Premier league",
    class: "two",
    sportUrl: "football",

  },
];

export const createTabContentData = (currentSortingTab) => {
  let tabContent = [
    {
      id: 1,
      CategoryName: "Location",
      Icon: (
        <LocationIcon
          color={currentSortingTab === "Location" ? "#FFDD00" : "#FFF"}
        />
      ),
    },
    {
      id: 2,
      CategoryName: "Date",
      Icon: (
        <CalanderIcon
          color={currentSortingTab === "Date" ? "#FFDD00" : "#FFF"}
        />
      ),
    },
    {
      id: 3,
      CategoryName: "Availability",
      Icon: (
        <AvailibilityIcon
          color={currentSortingTab === "Availability" ? "#FFDD00" : "#FFF"}
        />
      ),
    },
    {
      id: 4,
      CategoryName: "Price-Range",
      Icon: (
        <PriceRangeIcon
          color={currentSortingTab === "Price-Range" ? "#FFDD00" : "#FFF"}
        />
      ),
    },
    {
      id: 5,
      CategoryName: "Team",
      Icon: (
        <TeamIcon color={currentSortingTab === "Team" ? "#FFDD00" : "#FFF"} />
      ),
      className: "active",
    },

    {
      id: 6,
      CategoryName: "Competition",
      Icon: (
        <CompeteIcon
          color={currentSortingTab === "Competition" ? "#FFDD00" : "#FFF"}
        />
      ),
    },
  ];
  return tabContent;
};
